





















































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Company } from '@/api/model/company'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputSelectUser extends Vue {
    @Ref() validator!: ProviderInstance
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly placeholder!: string
    @Prop() readonly users!: User[]
    @Prop() readonly value!: User
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    internalValue: User = null
    showOptions: boolean = false
    filteredUsers: User[] = []

    created() {
        this.internalValue = this.value
        this.filteredUsers = this.users
        window.addEventListener('click', this.onOutsideClick)
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('users')
    onUsersChanged() {
        if (this.internalValue && !this.users.some((user: User) => user.id === this.internalValue.id)) {
            this.internalValue = null
        }
        this.filteredUsers = this.users
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        await this.validator.validate(this.internalValue)
        this.$emit('input', this.internalValue)
    }

    applyClass(option: User) {
        if (this.value && this.value.id === option.id) {
            return ['input-select__option--selected']
        }

        return []
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions

            // Give search input focus on open.
            if (this.showOptions) {
                this.onSearchChange(null)
                this.$nextTick(() => this.$el
                    .getElementsByClassName('search')[0]
                    .getElementsByTagName('input')[0]
                    .focus())
            }
        }
    }

    selectOption(option: User): void {
        this.internalValue = option
        this.showOptions = false
    }

    getKey(user: User): string {
        if (user.keyVueBranches[0]) {
            return `${user.id}___${user.keyVueBranches[0].id}`
        }

        return `${user.id}`
    }

    get isClearable(): boolean {
        return this.clearable && this.internalValue !== null && !this.disabled
    }

    clear(): void {
        this.internalValue = null
        this.showOptions = false
    }

    get selectedOption() {
        if (!this.value) {
            return null
        }
        return this.users.find(value => value.id === this.value.id)
    }

    get componentClass(): object {
        return {
            'input-select-user': true,
            'input-select': true,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
        }
    }

    onSearchChange(query: string) {
        if (query && query.length > 0) {
            try {
                query = query.toLowerCase()
                const queries = query.split(' ')
                this.filteredUsers = this.users.filter(user => {
                    let match = true
                    queries.forEach(q => match = match && user.name.toLowerCase().includes(q))
                    return match
                })
            } catch (error) {
                console.log(error)
            }
        } else {
            this.filteredUsers = this.users
        }
    }

    isCurrentCompany(company: Company): boolean {
        return this.$currentCompany.id === company.id
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
